import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      eyebrow="How we handle your data"
      intro="Tour Trips India Holidays respects your privacy and is committed to handling your personal data fairly, lawfully and transparently. This policy explains what data we collect, why, how long we keep it, and your rights."
      seoDesc="Privacy policy of Tour Trips India Holidays — what data we collect, why, and your rights under GDPR / Indian DPDP Act."
      sections={[
        {
          heading: "1. Who we are",
          paragraphs: [
            "Tour Trips India Holidays is a tour-operator business registered in Agra, Uttar Pradesh, India. We act as the Data Controller for the personal data we collect through this website and our booking flow.",
            "Contact: info@ttiholidays.com · WhatsApp +91 70177 98524 · P-10, Tajnagri Phase 1, Agra 282001.",
          ],
        },
        {
          heading: "2. What data we collect",
          paragraphs: [
            "Account data: name, email, password (hashed using bcrypt), phone, country, preferred language. Collected when you create an account.",
            "Booking data: traveler names, passport details, dates of birth, nationality, dietary preferences, mobility needs. Collected when you create a booking — necessary to operate the tour and arrange hotel/permit bookings.",
            "Payment data: we never store your card details on our servers; when payment is arranged we send you a secure link and only receive a transaction confirmation.",
            "Communications: emails, WhatsApp messages, contact-form submissions, newsletter subscriptions.",
            "Technical data: IP address, browser type, pages visited, language preference (Google Translate cookie). Used for security, analytics, and to improve the website.",
          ],
        },
        {
          heading: "3. Why we use your data (legal basis)",
          paragraphs: [
            "Contract performance: to operate your tour, arrange transfers, hotels and permits, issue invoices and PDF itineraries, and send booking confirmations.",
            "Legitimate interest: to improve our services, prevent fraud, and respond to support requests.",
            "Consent: for marketing emails, newsletters and promotional WhatsApp messages. You can withdraw consent any time via the unsubscribe link in our emails.",
            "Legal obligation: to keep records as required by Indian tax law (typically 7 years) and respond to lawful requests from regulatory authorities.",
          ],
        },
        {
          heading: "4. Who we share data with",
          paragraphs: [
            "Hotel, transport and monument partners (only the minimum necessary — name, nationality, ID where required by Indian law).",
            "Payment processor: PCI-DSS compliant partner banks and gateways selected per transaction.",
            "Email service: Resend, used to send your booking confirmation and PDF itinerary.",
            "Object storage: Emergent (Cloudflare R2 / S3-compatible) — for uploaded photos.",
            "We do NOT sell your personal data to third parties.",
          ],
        },
        {
          heading: "5. International transfers",
          paragraphs: [
            "Some of our processors (Resend for email) are based in the EU/US. Where we transfer personal data outside India, we rely on Standard Contractual Clauses or equivalent safeguards.",
          ],
        },
        {
          heading: "6. How long we keep your data",
          paragraphs: [
            "Booking data: 7 years from booking date (Indian tax law requirement).",
            "Account data: until you delete your account, plus a 30-day grace period.",
            "Newsletter subscriptions: until you unsubscribe.",
            "Analytics logs: 12 months.",
          ],
        },
        {
          heading: "7. Your rights",
          paragraphs: [
            "Under the GDPR (if you are in the EU/EEA) and the Indian Digital Personal Data Protection Act 2023, you have the right to: access your data, correct inaccuracies, delete (right to be forgotten where legal), export your data in machine-readable format, object to processing, withdraw consent, and lodge a complaint with your local data protection authority.",
            "To exercise any of these rights, email info@ttiholidays.com. We respond within 30 days.",
          ],
        },
        {
          heading: "8. Cookies",
          paragraphs: [
            "Essential cookies: authentication token (tti_token) — required for login.",
            "Functional cookies: language preference (googtrans) — set by the language switcher.",
            "No third-party advertising / tracking cookies are used on this site.",
          ],
        },
        {
          heading: "9. Children's privacy",
          paragraphs: [
            "Our services are not directed at children under 13. We do not knowingly collect data from children. If you believe we have, please contact us and we will delete the data.",
          ],
        },
        {
          heading: "10. Changes to this policy",
          paragraphs: [
            "We may update this policy occasionally. The 'Last updated' date at the top reflects the most recent revision. Material changes will be notified via email to active customers.",
          ],
        },
      ]}
    />
  );
}
